var RakeNonFederatedSummary = React.createClass({
    propTypes: {
        eventHandler: React.PropTypes.func.isRequired,
        searchResults: React.PropTypes.object.isRequired,
        resultCount: React.PropTypes.number,
        categoryCount: React.PropTypes.number,
        onSolClicked: React.PropTypes.func.isRequired,
        onEmailClicked: React.PropTypes.func.isRequired,
        onPreviewClicked: React.PropTypes.func.isRequired
    },
    getDefaultProps() {
        return {
            resultCount: 5,
            categoryCount: 2
        }
    },
    categoryClicked(taxPath) {
        this.props.eventHandler({actionType: 'categoryChanged', taxPath: taxPath});
        this.showRakeTab();
    },
    showRakeTab() {
        RA.ResultsPage.showTab("#rakeNonFederatedResults");
    },
    getSummaryHits() {
        let results = this.props.searchResults.results;
        let ubound = Math.min(results.length, this.props.resultCount);

        results = results.slice(0, ubound);

        return results;
    },
    getSummaryBrowsePaths() {
        let categories = this.props.searchResults.browsePaths;

        // sort affects other components using this variable - use map, then sort instead
        //categories.sort((a, b) => b.hits - a.hits);

        // convert to map of array {index, hit count}
        let hitCounts = categories.map((cat, i) => {
            return {index: i, count: cat.hits }
        });

        // sort by hit count - descending
        hitCounts.sort((a, b) => b.count - a.count);

        // get slice
        let ubound = Math.min(hitCounts.length, this.props.categoryCount);
        hitCounts = hitCounts.slice(0, ubound);

        // return array of categories with index position from the hitCount array
        return hitCounts.map(hitCount => {
            return categories[hitCount.index];
        });

    },
    renderSummary() {
        let { searchResults } = this.props;

        if (searchResults.totalHits == 0) {
            return <NoResults />
        }

        let resultsLabel = searchResults.totalHits == 1 ? Labels.getLabel("result") : Labels.getLabel("results");
        let didYouMean = searchResults.didYouMean;
        let selectedTaxonomy = searchResults.query.taxPath;
        let selectedTaxonomyLabel = Labels.getLabel("Currently searching");

        return (
            <div>
                <div className="result-summary__stats">
                    <span className="text-muted">{`${searchResults.totalHits} ${resultsLabel} - `}</span>
                    <a href="#" className="text-muted" onClick={this.showRakeTab}>
                        {Labels.getLabel("Show All")}
                    </a>
                    <KBDidYouMean didYouMean={didYouMean}/>
                </div>
                <RakeNonFederatedResultsList hits={this.getSummaryHits()} showSummary={false} showHitSummary={false} onEmailClicked={this.props.onEmailClicked}
                                             onSolClicked={this.props.onSolClicked} onPreviewClicked={this.props.onPreviewClicked}/>
                { selectedTaxonomy ? <div className="cat-matches"><h3 className="cat-matches__title"><span className="alltab_taxonomy_clicked">{selectedTaxonomyLabel} </span> {selectedTaxonomy}</h3></div> : <span></span>}
                <RakeNonFederatedSummaryCategories browsePaths={this.getSummaryBrowsePaths()} onCategoryClicked={this.categoryClicked} />
            </div>
        )
    },
    render() {
        return (
            <div>
                <h3 className="result-summary__head">
                    <a href="#" className="result-summary__head-link -kb" onClick={this.showRakeTab}>
                        <i className="glyphicon glyphicon-book result-summary__head-icon"></i>
                        {Labels.getLabel("Knowledgebase External Sources")}
                    </a>
                </h3>
                {this.renderSummary()}
            </div>
        )
    }
});